module.exports = __webpack_public_path__ + "img/wxccYTSIO.fb27a8f0.png";